import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FeaturedPlayListIcon(props: IconProps) {
    return <Icon {...props} iconKey={"featured_play_list"}/>
}
